import { Button, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import { IOmniumType } from "../../../Models/Entities";
import { refreshTables } from "../../../Store/atoms";

interface IButtonProps {
  type: IOmniumType;
  setSelected(type: IOmniumType, ctrlKey: boolean): void;
  unsetSelected(type: IOmniumType): void;
  active: boolean;
}

const useStyles = makeStyles({
  displayButton: {
    fontSize: "1.2rem",
    width: "calc(100% - 2rem)",
    backgroundColor: "#e9ecf5;",
    color: "#1c2321",
    margin: "0.5rem 1rem",
    textTransform: "none",
  },
  displayButtonActive: {
    fontSize: "1.2rem",
    width: "calc(100% - 2rem)",
    color: "#e9ecf5;",
    backgroundColor: "#1c2321",
    margin: "0.5rem 1rem",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#434b48",
    },
  },
});

export default ({ type, setSelected, unsetSelected, active }: IButtonProps) => {
  const classes = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (event.ctrlKey) {
      setSelected(type, true);
    } else {
      if (active) {
        unsetSelected(type);
      } else {
        setSelected(type, false);
      }
    }
  };

  return (
    <Button
      value={type.id}
      onClick={handleClick}
      key={type.id}
      className={active ? classes.displayButtonActive : classes.displayButton}
      variant="outlined"
    >
      {type.name}
    </Button>
  );
};
